<template>
    <div>
        <div v-if="(hired || rejected) && showIcon">
            <svg-icon
                v-if="rejected"
                type="do-not-disturb-on-filled"
                class="text-semantic-error"
                :size="size"
            ></svg-icon>
            <svg-icon
                v-else
                :style="{ color: color }"
                type="check-circle-filled"
                :size="size"
            ></svg-icon>
        </div>
        <div
            v-else
            class=" rounded-32 border-2 p-2"
            :class="sizeClass"
            :style="{ borderColor: color }"
        >
            <div
                class="w-full h-full rounded-32"
                :style="styleObject"
            ></div>
        </div>
    </div>
</template>

<script>
import Stage from '../../models/Stage'
import SvgIcon from './SvgIcon.vue';
import styles from '../../../../../../styles.config';
import tinycolor from 'tinycolor2';

export default {
    components: {
        'svg-icon': SvgIcon,
    },
    props: {
        stage: Stage,
        rejected: Boolean,
        progress: {
            type: Number,
            default: 0,
        },
        size: { type: String, default: '20'},
        showIcon: { type: Boolean, default: true},
    },
    computed: {
        sizeClass() {
            return 'w-' + this.size + ' h-' + this.size;
        },
        color () {
            if (this.stage) {
                return this.stage.color;
            }

            if (!this.progress) {
                return styles.colors.semantic.warning.DEFAULT;
            }

            if (this.progress >= 100) {
                return styles.colors.gradient[6];
            }

            return tinycolor.mix(
                styles.colors.blue.DEFAULT,
                styles.colors.green.DEFAULT,
                this.progress
            ).toHexString();
        },
        hired () {
            return this.stage ? this.stage.onboarding : this.progress >= 100;
        },
        styleObject () {

            let progress = this.stage ? this.stage.order * (100 / this.stage.sibling_count) : this.progress;

            return {
                background: 'conic-gradient(' + this.color + ' ' + progress + '%, transparent 0 ' + (100 - progress) + '%)'
            }
        }
    }
}
</script>
